module.exports = __webpack_public_path__ + "media/images/flags/AT-1fb3006e8f9ba1368d10a6c9a80ade3d.svg";